import { useCallback, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { useSAL3050_R01Store } from './Store_SAL3050_R01';
import { getSAL3050_R01HeaderList, getSAL3050_R01DetailList } from './Api_SAL3050_R01';
import { SAL3050_R01DetailDto, SAL3050_R01HeaderDto } from './Dto_SAL3050_R01';
import { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';
import { gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';

interface Props {
    gridRef: React.RefObject<AgGridReact<SAL3050_R01HeaderDto> | null>;
    detailGridRef: React.RefObject<AgGridReact<SAL3050_R01DetailDto> | null>;
    tabList: Tab[] | undefined;
    setMessage: (msg: string) => void;
    containerRef: React.RefObject<HTMLDivElement | null>;
    isResizing: React.MutableRefObject<boolean>;
}

export const Content_SAL3050_R01 = (props: Props) => {
    const { gridRef, setMessage } = props;

    const {
        SAL3050_R01Filter, setSAL3050_R01PastFilter,
        setSAL3050_R01List,
        selectedSAL3050_R01, setSelectedSAL3050_R01,
        setSAL3050_R01DetailList,
        setScrollTop, setDetailScrollTop,
        setAllCount,
    } = useSAL3050_R01Store();

    const { setLoadingSpinner } = useLoadingSpinnerStore();

    useFetchActionbarAuth('SAL3050_R01');

    const fetchData = useCallback(async () => {
        setScrollTop(null);
        setDetailScrollTop(null);
        setLoadingSpinner(true);

        try {
            const res = await getSAL3050_R01HeaderList('search', SAL3050_R01Filter);
            const list = res.data.data as SAL3050_R01HeaderDto[];

            setSAL3050_R01List(list);
            setAllCount(list.length);

            if (list.length > 0) {
                gridRefSelectedRowHandler(gridRef, setSelectedSAL3050_R01, () => true);
                setSAL3050_R01PastFilter(SAL3050_R01Filter);
                ShowSuccessFetch(setMessage, `조회 완료 (총 ${list.length}건)`);
                setTimeout(() => setMessage(''), 5000);
            } else {
                showWarning('데이터가 없습니다.');
                setSelectedSAL3050_R01(undefined);
                setSAL3050_R01DetailList([]);
            }
        } finally {
            setLoadingSpinner(false);
        }
    }, [SAL3050_R01Filter, gridRef, setAllCount, setDetailScrollTop, setLoadingSpinner,
        setMessage, setSAL3050_R01DetailList, setSAL3050_R01List, setSAL3050_R01PastFilter,
        setScrollTop, setSelectedSAL3050_R01]);

    useEffect(() => {
        if (!selectedSAL3050_R01) {
            setSAL3050_R01DetailList([]);
            return;
        }

        const fetchDetail = async () => {
            setDetailScrollTop(null);
            const res = await getSAL3050_R01DetailList('search', {
                ...SAL3050_R01Filter,
                customCd: selectedSAL3050_R01.customCd,
            });
            const list = res.data.data as SAL3050_R01DetailDto[];

            if (list.length > 0) {
                setSAL3050_R01DetailList(list);
                setMessage(`${selectedSAL3050_R01.customNm} 상세 ${list.length}건 조회`);
                setTimeout(() => setMessage(''), 5000);
            } else {
                showWarning('상세내역이 없습니다.');
                setSAL3050_R01DetailList([]);
            }
        };

        fetchDetail();
    }, [selectedSAL3050_R01, SAL3050_R01Filter, setDetailScrollTop, setMessage, setSAL3050_R01DetailList]);

    return { fetchData };
};
